import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentStep: 1,
    isEditMode: false,
    errors: {},
    // Fields
    firstName: "", middleName: "", lastName: "", email: "", gender: "",
    maritalStatus: "", birthPlace: "", birthDate: "", birthTime: "",
    heightFeet: "", heightInches: "", weight: "", complexion: "", bodyBuild: "", bloodGroup: "", differentlyAbled: false,disabilityDescription:"",
    petName: "", maternalSurname: "", nativePlace: "", gotra: "",
    brothersMarried: "", brothersUnmarried: "", sistersMarried: "", sistersUnmarried: "",
    highestEducation: "", highestEducationOther: "",secondHighestEducationOther: "", secondHighestEducation: "", specialization: "", jobType: "",
    organizationName: "", occupation: "", designation: "", income: "", workLocation: "",
    mainPhoto: null, galleryPhotos: [], videoFile: null,
    expectations: "", expectationsDescription:"", matchHoroscope: false, contactName: "",contactNumber: "",address: "",secContactName: "",secContactNumber: "",correspondenceAddress: "",
    facebook: "", linkedin: "", instagram: "", contactCountryCode: "", secContactCountryCode: "", primaryCountryId: "", primaryCountry: ""
};

const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        updateField: (state, action) => {
            const { field, value } = action.payload;
            state[field] = value;
            if (state.errors[field]) delete state.errors[field];
        },
        setStep: (state, action) => { state.currentStep = action.payload; },
        setErrors: (state, action) => { state.errors = action.payload; },
        clearErrors: (state) => { state.errors = {}; },
        addGalleryPhoto: (state, action) => { state.galleryPhotos.push(action.payload); },
        removeGalleryPhoto: (state, action) => {
            const indexToRemove = action.payload; // action.payload must be the index
            state.galleryPhotos = state.galleryPhotos.filter((_, index) => index !== indexToRemove);
        },
        populateForEdit: (state, action) => {
            return { ...state, ...action.payload, isEditMode: true, currentStep: 1, errors: {} };
        },
        resetForm: () => initialState,
    },
});

export const { updateField, setStep, setErrors, clearErrors, addGalleryPhoto, removeGalleryPhoto, populateForEdit, resetForm } = profileSlice.actions;
export default profileSlice.reducer;